var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.052 14l8.25 11.031L13 34h1.869l7.268-7.853L28.01 34h6.358l-8.714-11.652L33.382 14h-1.869l-6.694 7.232L19.41 14h-6.358zm2.748 1.376h2.921l12.9 17.247h-2.922L15.8 15.376z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/x-twitter.ddf4e3db.svg";
export { SvgXTwitter as ReactComponent };